import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInitialAlertAdr } from '@rsos/components/capstone/DataCards/adrDataSlice';
import { Text, Button } from '@rsos/components/capstone/base';
import { NOTIFIED_AGENCY } from '@rsos/constants/alertsRoutingConstants';
import {
  setChatSelectedAlertID,
  fetchAlertConversationStatus,
} from '@rsos/reduxDataStore/src/features/alerts/chatSlice';
import {
  addFollower,
  fetchAlert,
  updateAlertStatus,
} from '@rsos/reduxDataStore/src/features/alerts/incidentsSlice';
import { setSelectedCallerID } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import { Wrapper, Content } from './AlertToast.styles';
import { trackAcceptAlertFromToast } from './alertToastTracking';
import {
  getIconByEmergencyType,
  getButtonLabel,
  getButtonType,
  getAlertToastTextContent,
} from './utils';

const AlertToast = ({ alert }) => {
  const dispatch = useDispatch();

  const currentApplication = useSelector(
    state => state.sinatra.user.currentRole.application,
  );
  const currentOrg = useSelector(state => state.sinatra.user.currentOrg);
  const profile = useSelector(state => state.sinatra.user.profile);
  const userID = useMemo(() => profile?.id, [profile]);
  const currentOrgName = useMemo(() => currentOrg?.name, [currentOrg]);

  const irpVersion = useSelector(state => state.sinatra.irp.irpVersion);

  const {
    alert_id: alertID,
    emergency_type: emergencyType,
    associated_role_type: roleType,
  } = alert;

  const handleAccept = () => {
    const data = {
      alertID: alertID,
      org: currentOrgName,
      status: 'ACCEPTED',
    };
    dispatch(updateAlertStatus(data));
    dispatch(addFollower(userID));

    trackAcceptAlertFromToast({
      alertID,
      irpVersion,
      isTest: emergencyType?.name?.startsWith('TEST'),
    });

    dispatch(
      fetchAlert({
        currentApplication,
        currentOrgName,
        alertID: alertID,
        shouldSetID: true,
      }),
    ).then(() => {
      dispatch(setChatSelectedAlertID(alertID));
      dispatch(setSelectedCallerID(null));
      dispatch(
        fetchAlertConversationStatus({
          orgName: currentOrgName,
          conversationID: `chat-portal-default-${alertID.split('alert-')[1]}`,
        }),
      );
      dispatch(fetchInitialAlertAdr(alertID));
    });
  };

  return (
    <Wrapper>
      <Content>
        {getIconByEmergencyType(emergencyType?.name)}
        <Text size="normal" ellipsis>
          {getAlertToastTextContent(alert)}
        </Text>
      </Content>
      {roleType !== NOTIFIED_AGENCY && (
        <Button
          btnType={getButtonType(emergencyType?.name)}
          onClick={handleAccept}
          style={{ borderRadius: 10 }}
          dataName="alert-toast-accept-button"
        >
          {getButtonLabel(emergencyType?.name)}
        </Button>
      )}
    </Wrapper>
  );
};

export default AlertToast;
